import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgLightbulb = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.25 25.375a.875.875 0 0 1-.875.875h-8.75a.875.875 0 0 1 0-1.75h8.75a.875.875 0 0 1 .875.875Zm4.375-14a9.576 9.576 0 0 1-3.68 7.57 1.777 1.777 0 0 0-.695 1.399V21a1.75 1.75 0 0 1-1.75 1.75h-7A1.75 1.75 0 0 1 8.75 21v-.656a1.75 1.75 0 0 0-.681-1.385 9.579 9.579 0 0 1-3.694-7.53C4.347 6.216 8.56 1.875 13.768 1.75a9.625 9.625 0 0 1 9.857 9.625Zm-1.75 0A7.875 7.875 0 0 0 13.81 3.5c-4.266.1-7.708 3.652-7.685 7.918a7.837 7.837 0 0 0 3.023 6.158 3.499 3.499 0 0 1 1.352 2.768V21h7v-.656a3.516 3.516 0 0 1 1.364-2.773 7.837 7.837 0 0 0 3.011-6.196Zm-1.762-1.022a6.3 6.3 0 0 0-5.092-5.091.875.875 0 0 0-.292 1.726c1.813.305 3.35 1.843 3.658 3.658a.875.875 0 1 0 1.726-.293Z" />
  </svg>
);
export default SvgLightbulb;
